import { HttpRequest, HttpMethod } from "./http";

class MemberLevelProvider extends HttpRequest {
    list(params) {
        return this.request(HttpMethod.Get, "/api/v1/bo/member-levels", params);
    }

    create(payload) {
        return this.request(HttpMethod.Post, "/api/v1/bo/member-levels", payload);
    }

    update(id, payload) {
        return this.request(HttpMethod.Put, `/api/v1/bo/member-levels/${id}`, payload);
    }

    remove(id) {
        return this.request(HttpMethod.Delete, `/api/v1/bo/member-levels/${id}`);
    }
}

export default MemberLevelProvider;
